export default __webpack_public_path__ + "static/media/francheville10.a8a45b5b.jpg";